var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118.835,
    height: 147.285,
    viewBox: "0 0 118.835 147.285",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14296",
    "data-name": "Group 14296",
    transform: "translate(-147.582 -374.358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14294",
    "data-name": "Group 14294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14293",
    "data-name": "Group 14293",
    transform: "translate(-426.934 -64.397)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14269",
    "data-name": "Group 14269",
    transform: "translate(621.04 500.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14267",
    "data-name": "Group 14267",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3034",
    "data-name": "Path 3034",
    d: "M752.491,687.7a.688.688,0,0,1-.437-1.221c5.863-4.811,6.241-12.82,6.244-12.9a.681.681,0,0,1,.715-.661.689.689,0,0,1,.661.715c-.014.353-.411,8.712-6.747,13.911A.687.687,0,0,1,752.491,687.7Z",
    transform: "translate(-751.802 -672.914)",
    fill: "#86868b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14268",
    "data-name": "Group 14268",
    transform: "translate(19.129 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3035",
    "data-name": "Path 3035",
    d: "M831.88,687.7a.686.686,0,0,1-.436-.156c-6.336-5.2-6.733-13.558-6.747-13.911a.689.689,0,0,1,1.376-.054h0c0,.08.4,8.1,6.244,12.9a.689.689,0,0,1-.437,1.221Z",
    transform: "translate(-824.696 -672.914)",
    fill: "#86868b"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3036",
    "data-name": "Path 3036",
    d: "M730.2,749.468s.7-6-4.961-11.847c-4.79-4.946-19.656-13.027-23.153-14.895-.073,8.185-5.5,14.794-12.185,14.794s-12.112-6.608-12.185-14.794c-3.5,1.868-18.363,9.949-23.154,14.895-5.664,5.848-4.961,11.847-4.961,11.847Z",
    transform: "translate(-55.361 -209.45)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3037",
    "data-name": "Path 3037",
    d: "M728.26,748.222a.644.644,0,0,1-.081-.005.689.689,0,0,1-.6-.763c.01-.093.558-5.785-4.772-11.289-4.372-4.514-17.561-11.836-22.013-14.245-.547,8.011-6.119,14.353-12.831,14.353s-12.284-6.342-12.831-14.353c-4.452,2.408-17.641,9.73-22.013,14.245-5.375,5.549-4.779,11.231-4.772,11.288a.688.688,0,1,1-1.367.16c-.03-.258-.674-6.392,5.151-12.406,4.782-4.938,19.061-12.747,23.324-15.023a.688.688,0,0,1,1.013.6c.07,7.781,5.227,14.111,11.5,14.111s11.427-6.33,11.5-14.111a.688.688,0,0,1,1.013-.6c4.263,2.276,18.542,10.087,23.324,15.023,5.824,6.014,5.181,12.148,5.151,12.406A.689.689,0,0,1,728.26,748.222Z",
    transform: "translate(-53.418 -207.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14270",
    "data-name": "Group 14270",
    transform: "translate(616.031 458.083)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3038",
    "data-name": "Path 3038",
    d: "M751.225,556.956a18.531,18.531,0,0,1-18.51-18.51v-8A18.516,18.516,0,0,1,747,512.422a.688.688,0,1,1,.313,1.341,17.055,17.055,0,0,0-13.218,16.684v8a17.133,17.133,0,1,0,34.266,0v-6.18a.688.688,0,0,1,1.377,0v6.18A18.531,18.531,0,0,1,751.225,556.956Z",
    transform: "translate(-732.715 -512.404)",
    fill: "#86868b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14271",
    "data-name": "Group 14271",
    transform: "translate(651.674 477.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3039",
    "data-name": "Path 3039",
    d: "M869.224,592.631a.688.688,0,0,1-.688-.688v-5.694a.688.688,0,0,1,1.377,0v4.931A3.193,3.193,0,0,0,872,586.492a.688.688,0,1,1,1.2-.679,4.569,4.569,0,0,1-3.976,6.818Z",
    transform: "translate(-868.536 -585.464)",
    fill: "#86868b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14272",
    "data-name": "Group 14272",
    transform: "translate(609.88 474.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3040",
    "data-name": "Path 3040",
    d: "M716.114,585.8c-3.048,0-6.84,0-6.84-5.656s3.793-5.655,6.84-5.655a.688.688,0,0,1,.689.688v9.934A.689.689,0,0,1,716.114,585.8Zm-.689-9.93c-3.059.041-4.774.471-4.774,4.274s1.715,4.234,4.774,4.275Z",
    transform: "translate(-709.274 -574.49)",
    fill: "#86868b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14273",
    "data-name": "Group 14273",
    transform: "translate(622.863 455.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3041",
    "data-name": "Path 3041",
    d: "M789.144,525.179c-7.808,0-11.561-4.933-16.67-11.65-.953-1.253-1.939-2.549-3.018-3.9-6.507-8.168-9.556-5.991-9.586-5.968a.682.682,0,0,1-.964-.087.7.7,0,0,1,.088-.975,3.415,3.415,0,0,1,2.508-.582c2.629.26,5.667,2.532,9.03,6.754,1.089,1.366,2.079,2.669,3.037,3.928,5.272,6.93,8.752,11.512,16.578,11.078,1.756-.1,3.331-.226,4.683-.385a.689.689,0,0,1,.161,1.368c-1.38.162-2.984.295-4.768.393Q789.671,525.179,789.144,525.179Z",
    transform: "translate(-758.746 -501.99)",
    fill: "#86868b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14274",
    "data-name": "Group 14274",
    transform: "translate(630.46 492.701)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3042",
    "data-name": "Path 3042",
    d: "M795.324,650.457h-5.164A2.463,2.463,0,0,1,787.7,648v-1.215a2.463,2.463,0,0,1,2.461-2.461h5.164a2.463,2.463,0,0,1,2.46,2.461V648A2.463,2.463,0,0,1,795.324,650.457Zm-5.164-4.759a1.085,1.085,0,0,0-1.083,1.084V648a1.085,1.085,0,0,0,1.083,1.083h5.164A1.085,1.085,0,0,0,796.407,648v-1.215a1.085,1.085,0,0,0-1.083-1.084Z",
    transform: "translate(-787.699 -644.321)",
    fill: "var(--primary-color)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14275",
    "data-name": "Group 14275",
    transform: "translate(611.62 483.578)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3043",
    "data-name": "Path 3043",
    d: "M735.434,623.045a.7.7,0,0,1-.157-.018L724.464,620.5a7.5,7.5,0,0,1-4.767-3.53l-3.7-6.382a.688.688,0,1,1,1.191-.69l3.7,6.382a6.12,6.12,0,0,0,3.889,2.879l10.813,2.523a.689.689,0,0,1-.156,1.359Z",
    transform: "translate(-715.904 -609.559)",
    fill: "var(--primary-color)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14276",
    "data-name": "Group 14276",
    transform: "translate(633.852 438.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3044",
    "data-name": "Path 3044",
    d: "M836.117,507.284c-.333,0-.668-.006-1.008-.018-16.443-.589-21.824-9.564-22.045-9.946a.688.688,0,1,1,1.191-.69c.05.086,5.271,8.7,20.9,9.26a25.634,25.634,0,0,0,17.741-6.185,30.316,30.316,0,0,0,5.392-5.827c-5.41-1.347-8.4-7.731-12.8-17.108q-.61-1.3-1.26-2.68a76.517,76.517,0,0,1-3.61-10.05c-2.921-9.445-5.941-19.211-16.629-22.547-6.737-2.1-12.7-1.762-17.237.986a13.808,13.808,0,0,0-4.831,4.751.689.689,0,1,1-1.221-.637,15.037,15.037,0,0,1,5.339-5.292c3.408-2.062,9.36-3.931,18.361-1.122,11.379,3.551,14.508,13.669,17.534,23.454a75.6,75.6,0,0,0,3.539,9.868q.652,1.379,1.262,2.684c4.48,9.556,7.44,15.869,12.78,16.52a.688.688,0,0,1,.511,1.031,29.536,29.536,0,0,1-6.21,6.994A27.493,27.493,0,0,1,836.117,507.284Z",
    transform: "translate(-800.624 -438.755)",
    fill: "#86868b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14277",
    "data-name": "Group 14277",
    transform: "translate(579.958 439.845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3045",
    "data-name": "Path 3045",
    d: "M621.147,510.17c-9.668,0-15.893-3.568-19.556-6.816a23.468,23.468,0,0,1-6.294-8.644.688.688,0,0,1,.492-.905c8.454-1.951,11.01-10.61,13.715-19.778.912-3.089,1.854-6.283,3.041-9.2,5.915-14.546,14.331-21.921,25.015-21.921,12.52,0,14.636,4.2,14.72,4.378a.689.689,0,0,1-1.241.6c-.048-.087-2.1-3.6-13.479-3.6-10.069,0-18.056,7.087-23.74,21.063-1.161,2.854-2.093,6.015-3,9.071-2.619,8.876-5.326,18.045-13.932,20.524a23.527,23.527,0,0,0,5.663,7.429c5.765,5.083,13.788,7.211,23.206,6.158,7.076-1.353,12.021-4.481,12.031-7.61a.688.688,0,0,1,.688-.687h0a.688.688,0,0,1,.686.69c-.012,3.923-5.183,7.441-13.176,8.963l-.052.008A42.848,42.848,0,0,1,621.147,510.17Z",
    transform: "translate(-595.255 -442.906)",
    fill: "#86868b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14278",
    "data-name": "Group 14278",
    transform: "translate(588.464 451.92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3046",
    "data-name": "Path 3046",
    d: "M628.354,529.863a.689.689,0,0,1-.214-1.343c.067-.023,5.179-1.848,7.907-11.352q.355-1.237.705-2.482c2.626-9.287,5.341-18.891,12.236-25.573a.688.688,0,1,1,.958.989c-6.629,6.424-9.293,15.846-11.869,24.958q-.352,1.247-.707,2.487c-2.953,10.29-8.567,12.2-8.8,12.281A.69.69,0,0,1,628.354,529.863Z",
    transform: "translate(-627.666 -488.919)",
    fill: "#86868b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14279",
    "data-name": "Group 14279",
    transform: "translate(644.08 443.484)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3047",
    "data-name": "Path 3047",
    d: "M875.423,503.571a.688.688,0,0,1-.53-.248c-5.58-6.71-9.832-20.539-12.117-27.969-.206-.671-.4-1.286-.566-1.833-1.92-6.145-3.852-10.749-11.268-14.056-6.895-3.075-10.016.2-10.145.34a.689.689,0,0,1-1.023-.922c.154-.172,3.868-4.182,11.73-.676,7.926,3.535,10.058,8.621,12.021,14.9.171.549.361,1.166.568,1.839,2.256,7.337,6.456,21,11.86,27.493a.688.688,0,0,1-.529,1.129Z",
    transform: "translate(-839.598 -456.774)",
    fill: "#86868b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3048",
    "data-name": "Path 3048",
    d: "M677.019,822.006H585.685a11.181,11.181,0,0,0-11.169,11.169v35.541h1.377V833.175a9.8,9.8,0,0,1,9.792-9.792h91.334a9.8,9.8,0,0,1,9.792,9.792v35.541h1.377V833.175A11.181,11.181,0,0,0,677.019,822.006Z",
    transform: "translate(0 -282.676)",
    fill: "#86868b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14285",
    "data-name": "Group 14285",
    transform: "translate(673.115 544.342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3053",
    "data-name": "Path 3053",
    d: "M959.358,867.186a.688.688,0,0,1-.688-.689V850.224a7.75,7.75,0,0,0-7.741-7.741.688.688,0,0,1,0-1.377,9.129,9.129,0,0,1,9.118,9.118V866.5A.689.689,0,0,1,959.358,867.186Z",
    transform: "translate(-950.24 -841.106)",
    fill: "#86868b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14286",
    "data-name": "Group 14286",
    transform: "translate(579.781 544.342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3054",
    "data-name": "Path 3054",
    d: "M595.269,868.475a.689.689,0,0,1-.689-.689V850.224a9.129,9.129,0,0,1,9.118-9.118h8.885a.688.688,0,1,1,0,1.377H603.7a7.75,7.75,0,0,0-7.741,7.741v17.562A.688.688,0,0,1,595.269,868.475Z",
    transform: "translate(-594.58 -841.106)",
    fill: "#86868b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14287",
    "data-name": "Group 14287",
    transform: "translate(615.613 518.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3055",
    "data-name": "Path 3055",
    d: "M750.049,761.575a19.069,19.069,0,0,1-12.808-4.914,18.725,18.725,0,0,1-6.116-12.068.688.688,0,1,1,1.37-.135,17.686,17.686,0,0,0,33.393,5.974.688.688,0,1,1,1.233.613A18.926,18.926,0,0,1,750.049,761.575Z",
    transform: "translate(-731.121 -743.836)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14288",
    "data-name": "Group 14288",
    transform: "translate(588.439 517.154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3056",
    "data-name": "Path 3056",
    d: "M628.259,758.094a.69.69,0,0,1-.665-.868,39.416,39.416,0,0,1,3.661-8.363c3.994-7.027,13.147-11.13,13.535-11.3a.689.689,0,0,1,.556,1.26c-.091.04-9.128,4.1-12.894,10.722a38.652,38.652,0,0,0-3.528,8.041A.689.689,0,0,1,628.259,758.094Z",
    transform: "translate(-627.57 -737.503)",
    fill: "#86868b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14289",
    "data-name": "Group 14289",
    transform: "translate(664.837 517.154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3057",
    "data-name": "Path 3057",
    d: "M934.371,758.929h-.029a.688.688,0,0,1-.659-.717c0-.026.067-2.927-2.412-7.543-4.06-7.56-12.123-11.824-12.2-11.866a.688.688,0,0,1,.635-1.222c.346.18,8.515,4.493,12.781,12.436,2.678,4.986,2.581,8.122,2.575,8.253A.689.689,0,0,1,934.371,758.929Z",
    transform: "translate(-918.696 -737.503)",
    fill: "#86868b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14290",
    "data-name": "Group 14290",
    transform: "translate(651.49 521.135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3058",
    "data-name": "Path 3058",
    d: "M868.644,754.291a.809.809,0,0,1-.161-1.6.823.823,0,0,1,.162-.016.809.809,0,1,1,0,1.617Z",
    transform: "translate(-867.836 -752.674)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14291",
    "data-name": "Group 14291",
    transform: "translate(599.595 544.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3059",
    "data-name": "Path 3059",
    d: "M670.891,842.265a.809.809,0,0,1-.674-1.255.8.8,0,0,1,.513-.346.809.809,0,1,1,.161,1.6Z",
    transform: "translate(-670.082 -840.648)",
    fill: "#86868b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14292",
    "data-name": "Group 14292",
    transform: "translate(612.417 449.977)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3060",
    "data-name": "Path 3060",
    d: "M719.753,483.133a.812.812,0,0,1-.792-.647.808.808,0,0,1,.793-.97.811.811,0,0,1,.792.647.809.809,0,0,1-.631.954.82.82,0,0,1-.162.016Z",
    transform: "translate(-718.944 -481.516)",
    fill: "#86868b"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.9aa1f443e51b7257c9e0ddeaa940cb16.svg";
export { ForwardRef as ReactComponent };